var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniOrb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.3 42",
    enableBackground: "new 0 0 33.3 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M7.3 0l25 14 1 28-26-5zM1.9 37.2C.6 35.9 0 34.5 0 33c0-2 1.3-3.4 1.5-3.5l.1-.1c.9-.7 1.3-1.4 1.4-2.1 0-1-.9-1.8-.9-1.8l-.1-.1C.6 24 0 22.6.2 21.1.3 19.2 1.6 18 2 17.7c1.4-1.4.4-2.8 0-3.2-1.6-1.3-2-2.6-2-3.5 0-2.2 1.9-3.6 2.1-3.8.6-.5 1-1 1-1.5 0-.8-.8-1.7-1-1.9L4 1.4c.2.2 2.1 1.9 2.1 4.2 0 1-.4 2.5-2.1 3.9-.4.2-1 .9-1 1.4 0 .5.6 1 .9 1.2l.2.2c1.5 1.6 2.7 4.9 0 7.6l-.2.1s-.7.6-.8 1.4c0 .6.3 1.3.9 2 .4.4 1.9 1.9 1.9 4 0 1.6-.8 3-2.4 4.3-.4.5-1.2 1.7.5 3.4l-2.1 2.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniOrb);
export default __webpack_public_path__ + "static/media/mini_orb.826e6f3a7a8857dd2d8052baf8e811db.svg";
export { ForwardRef as ReactComponent };